var render = function () {
  var _vm$currentRound, _vm$currentRound$drop;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": ("" + (_vm.keyboardEnabled ? '' : 'full-height'))
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    ref: "buildASentenceDOM",
    staticClass: "build-a-sentence"
  }, [_vm.showDropdowns ? _c('div', {
    staticClass: "dropdowns",
    style: {
      width: ((_vm$currentRound = _vm.currentRound) === null || _vm$currentRound === void 0 ? void 0 : (_vm$currentRound$drop = _vm$currentRound.dropdowns) === null || _vm$currentRound$drop === void 0 ? void 0 : _vm$currentRound$drop.length) > 3 ? '100%' : '70%'
    },
    attrs: {
      "transition": "fade-05"
    }
  }, _vm._l(_vm.currentRound.dropdowns, function (dropdown) {
    return _c('div', {
      key: dropdown.id,
      staticClass: "option-container"
    }, [_c('dropdown', {
      attrs: {
        "id": dropdown.id,
        "label": dropdown.name,
        "drop-down-id": ("" + (dropdown.id)),
        "options": dropdown.answers.map(function (_ref) {
          var answer = _ref.answer;
          return answer;
        }),
        "enabled": !_vm.activeDropdown || dropdown.id === _vm.activeDropdown,
        "on-item-select": _vm.onDropdownSelect,
        "on-open": _vm.onDropdownOpen
      }
    })], 1);
  }), 0) : _vm._e(), _vm.showSentence ? _c('div', {
    staticClass: "complete-sentence",
    attrs: {
      "transition": "fade-05"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('p', {
    staticClass: "hidden-input"
  }, [_vm._v(_vm._s(_vm.sentence))]), _c('div', {
    staticClass: "sentence"
  }, [_c('blinking-cursor-text', {
    attrs: {
      "text": _vm.sentence,
      "text-step": 0
    }
  })], 1)]), _c('div', {
    staticClass: "right"
  }, [_c('img', {
    staticClass: "sentence-image-monochrome",
    attrs: {
      "alt": "",
      "src": _vm.monochromeImage
    }
  }), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showColor,
      expression: "showColor"
    }],
    staticClass: "sentence-image-color",
    attrs: {
      "transition": "fade",
      "src": _vm.colorImage,
      "alt": "Sentence image"
    }
  })])]) : _vm._e()])])], 2), _vm._t("keyboard")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }